export default "__VITE_ASSET__CvLgGQ3V__"